import ProductFilters from "~/features/search/components/ProductFilters";
import ProductGrid from "../components/ProductGrid";
import ReactDOM from 'react-dom';
import { RouterProvider } from 'react-router-dom';
import {router} from '../routes';
const ProductPage = () => {



  return ( 
    <RouterProvider router={router}/>
  )


}
ReactDOM.render(
  // <Router>
    <ProductPage />
  // </Router>
  , document.getElementById('react--product-page'));
